<template>
  <v-main>
    <v-layout>
      <v-flex>
        <v-text-field v-model="searchValue" label="搜尋"
                      :color="Theme.GREEN" placeholder="查詢"></v-text-field>
      </v-flex>
      <v-flex>
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
      <v-flex>
        <v-spacer></v-spacer>
        <v-btn style="float: right;" :color="Theme.PINK" dark @click.prevent="addNewData">新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <home-detail :title="editView.title" :visible="editView.visible"
                 :item-detail="editView.item"
                 :show-cancel="editView.showCancel"
                 @cancelEvent="editView.cancelEvent"
                 @confirmEvent="editView.confirmEvent">
    </home-detail>
  </v-main>
</template>

<script>
import TableView from "@/components/TableView";

import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import HomeDetail from "@/pages/home/HomeDetail";

export default {
  name: "home",
  components: {
    HomeDetail,
    TableView
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'sURL', text:'縮圖', sortable: false, isImage: true, },
        { value:'name', text:'標題', sortable: true },
        { value:'type', text:'類型', sortable: false, options: this.getBannerTypeList},
        { value:'hidden', text:'隱藏', sortable: false , options: [
            { key: 0, value: '否'},
            { key: 1, value: '是'}
          ]},
        { value:'sort', text:'排序', sortable: false },
        { value: 'startDate', text: '開始時間'},
        { value: 'endDate', text: '結束時間'},
        // { value:'updatedDate', text:'最後更新時間', sortable: false },
        { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    }
  },
  methods:{
    ...mapActions(['getHomeList','deleteHomeInfo']),
    async loadData(){
     try {
       this.loading = true;
       const res = await this.getHomeList({
         pageIndex: this.pagination.page,
         limit: this.pagination.itemsPerPage,
         searchValue:this.searchValue,
         type:'admin',
       });

       if (res.data.statusCode === 0){
         this.list = res.data.data.list;
         this.pagination.totalItems = res.data.data.header.totalCount;

         console.log(`getHomeList ${JSON.stringify(res.data.data.list)}`);
       }
     } catch (e) {
       console.log(`getHomeList error `, e);
     } finally {
       this.loading = false;
     }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此資料？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        if (!cell.item.saleURL){
          cell.item.saleURL = '';
        }
        this.editView.title = cell.key === 'add' ? '新增圖片':'修改圖片'
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
      }

    },
    searchEvent(){
      this.loadData();
    },
    reset(){
      this.searchValue = '';
      this.loadData();
    },
    async deleteEvent(item){
      const res = await this.deleteHomeInfo({
        bannerId: item.bannerId,
      });

      if (res.data.statusCode === 0){
        this.reset();
      }
    },
    addNewData(){
      this.cellEvent({
        key: 'add',
        item: {
          bannerId: this.uuid.v4(),
          name:'',
          type:0,
          hidden: false,
          sort:0,
          sURL:'',
          lURL:'',
          startDate:'',
          endDate:'',
          productId:'',
          enableType:0,
          link:'',
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
